// Getters
export const GET_PERSONS = "persons/GET_PERSONS";
export const GET_PERSON = "persons/GET_PERSON";

// Mutations
export const MUTATE_LOAD_PERSONS = "persons/MUTATE_LOAD_PERSONS";
export const MUTATE_ADD_PERSON = "persons/MUTATE_ADD_PERSON";
export const MUTATE_UPDATE_PERSON = "persons/MUTATE_UPDATE_PERSON";
export const MUTATE_DELETE_PERSON = "persons/MUTATE_DELETE_PERSON";

// Actions
export const ACTION_GET_PERSONS = "persons/ACTION_GET_PERSONS";
export const ACTION_GET_PERSON = "persons/ACTION_GET_PERSON";
export const ACTION_ADD_PERSON = "persons/ACTION_ADD_PERSON";
export const ACTION_UPDATE_PERSON = "persons/ACTION_UPDATE_PERSON";
export const ACTION_DELETE_PERSON = "persons/ACTION_DELETE_PERSON";
export const ACTION_IMPORT_PERSONS_AND_GROUPS_VALIDATE_FILE = "persons/ACTION_IMPORT_PERSONS_AND_GROUPS_VALIDATE_FILE";
export const ACTION_IMPORT_PERSONS_AND_GROUPS_IMPORT_FILE = "persons/ACTION_IMPORT_PERSONS_AND_GROUPS_IMPORT_FILE"
export const ACTION_UPDATE_PERSON_MEDIAFILES = "persons/ACTION_UPDATE_PERSON_MEDIAFILES"
export const ACTION_RESETPERSON_STATUS = "persons/ACTION_RESETPERSON_STATUS";
